var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AbstractAuthenticatedService from '../../../model/service/abstract-authenticated-service';
import DeleteActionTask from '../../task/mapping/action/delete-action-task';
import GetActionTask from '../../task/mapping/action/get-action-task';
import GetActionsTask from '../../task/mapping/action/get-actions-task';
import PostActionTask from '../../task/mapping/action/post-action-task';
import PutActionTask from '../../task/mapping/action/put-action-task';
export default class ActionService extends AbstractAuthenticatedService {
    /**
     * Find actions using search conditions
     * @param searchConditions
     * @returns
     */
    findActions(searchConditions) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetActionsTask();
            task.token = this.token;
            task.searchConditions = searchConditions;
            return this.runTask(task);
        });
    }
    /**
     * Load a single action
     * @param id
     * @returns
     */
    loadAction(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetActionTask();
            task.token = this.token;
            task.id = id;
            return this.runTask(task);
        });
    }
    /**
     * Create a new action
     *
     * @param action
     * @returns
     */
    createAction(action) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PostActionTask();
            task.token = this.token;
            task.action = action;
            return this.runTask(task);
        });
    }
    /**
     * Update an action
     *
     * @param action
     * @returns
     */
    updateAction(action) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PutActionTask();
            task.token = this.token;
            task.action = action;
            return this.runTask(task);
        });
    }
    /**
     * Delete an action
     *
     * @param id
     * @returns
     */
    deleteAction(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new DeleteActionTask();
            task.token = this.token;
            task.id = id;
            return this.runTask(task);
        });
    }
    /**
     * Return the types as an array
     */
    static get TYPES() {
        return [
            ActionService.TYPE_TAKE,
            ActionService.TYPE_ADD,
            ActionService.TYPE_SUBTRACT,
            ActionService.TYPE_MULTIPLY,
            ActionService.TYPE_DIVIDE,
            ActionService.TYPE_APPEND,
            ActionService.TYPE_PREPEND,
            ActionService.TYPE_TRIM,
            ActionService.TYPE_TRIM_START,
            ActionService.TYPE_TRIM_END,
            ActionService.TYPE_TRUNCATE,
            ActionService.TYPE_ROUND,
            ActionService.TYPE_ROUND_HALF_DOWN,
            ActionService.TYPE_CEIL,
            ActionService.TYPE_FLOOR,
            ActionService.TYPE_CASE_UPPER,
            ActionService.TYPE_CASE_LOWER,
            ActionService.TYPE_CASE_TITLE,
            ActionService.TYPE_CASE_SENTENCE,
            ActionService.TYPE_REPLACE,
            ActionService.TYPE_REPLACE_CI,
            ActionService.TYPE_PAD_START,
            ActionService.TYPE_PAD_END,
            ActionService.TYPE_SLUG,
            ActionService.TYPE_SPLIT,
            ActionService.TYPE_JOIN,
            ActionService.TYPE_ARRAY_CREATE,
            ActionService.TYPE_ARRAY_APPEND,
            ActionService.TYPE_ARRAY_PREPEND,
            ActionService.TYPE_ARRAY_FILTER,
            ActionService.TYPE_ARRAY_EXTRACT,
            ActionService.TYPE_HTML_STRIP_IMAGES,
            ActionService.TYPE_HTML_STRIP_STYLING,
            ActionService.TYPE_HTML_FROM_MARKDOWN,
            ActionService.TYPE_HTML_TO_MARKDOWN,
            ActionService.TYPE_URLENCODE,
        ];
    }
    /**
     * Return the type options for a select
     *
     * TODO update to use translations if possible
     */
    static get TYPE_OPTIONS() {
        return [
            {
                text: 'Take',
                value: ActionService.TYPE_TAKE,
            },
            {
                text: '',
                value: '',
                header: 'Maths',
            },
            {
                text: 'Add',
                value: ActionService.TYPE_ADD,
            },
            {
                text: 'Subtract',
                value: ActionService.TYPE_SUBTRACT,
            },
            {
                text: 'Multiply',
                value: ActionService.TYPE_MULTIPLY,
            },
            {
                text: 'Divide',
                value: ActionService.TYPE_DIVIDE,
            },
            {
                text: 'Round',
                value: ActionService.TYPE_ROUND,
            },
            {
                text: 'Round (half down)',
                value: ActionService.TYPE_ROUND_HALF_DOWN,
            },
            {
                text: 'Ceil',
                value: ActionService.TYPE_CEIL,
            },
            {
                text: 'Floor',
                value: ActionService.TYPE_FLOOR,
            },
            {
                text: '',
                value: '',
                header: 'String',
            },
            {
                text: 'Append',
                value: ActionService.TYPE_APPEND,
            },
            {
                text: 'Prepend',
                value: ActionService.TYPE_PREPEND,
            },
            {
                text: 'Trim',
                value: ActionService.TYPE_TRIM,
            },
            {
                text: 'Trim (start)',
                value: ActionService.TYPE_TRIM_START,
            },
            {
                text: 'Trim (end)',
                value: ActionService.TYPE_TRIM_END,
            },
            {
                text: 'Truncate',
                value: ActionService.TYPE_TRUNCATE,
            },
            {
                text: 'Upper case',
                value: ActionService.TYPE_CASE_UPPER,
            },
            {
                text: 'Lower case',
                value: ActionService.TYPE_CASE_LOWER,
            },
            {
                text: 'Title case',
                value: ActionService.TYPE_CASE_TITLE,
            },
            {
                text: 'Replace',
                value: ActionService.TYPE_REPLACE,
            },
            {
                text: 'Replace (ignore case)',
                value: ActionService.TYPE_REPLACE_CI,
            },
            {
                text: 'Pad (start)',
                value: ActionService.TYPE_PAD_START,
            },
            {
                text: 'Pad (end)',
                value: ActionService.TYPE_PAD_END,
            },
            {
                text: 'Slugify',
                value: ActionService.TYPE_SLUG,
            },
            {
                text: 'Split',
                value: ActionService.TYPE_SPLIT,
            },
            {
                text: 'Join',
                value: ActionService.TYPE_JOIN,
            },
            {
                text: 'URL Encode',
                value: ActionService.TYPE_URLENCODE,
            },
            {
                text: '',
                value: '',
                header: 'Array',
            },
            {
                text: 'Create Array',
                value: ActionService.TYPE_ARRAY_CREATE,
            },
            {
                text: 'Append',
                value: ActionService.TYPE_ARRAY_APPEND,
            },
            {
                text: 'Prepend',
                value: ActionService.TYPE_ARRAY_PREPEND,
            },
            {
                text: 'Filter',
                value: ActionService.TYPE_ARRAY_FILTER,
            },
            {
                text: 'Extract',
                value: ActionService.TYPE_ARRAY_EXTRACT,
            },
            {
                text: '',
                value: '',
                header: 'HTML',
            },
            {
                text: 'Strip Images',
                value: ActionService.TYPE_HTML_STRIP_IMAGES,
            },
            {
                text: 'Strip Styling',
                value: ActionService.TYPE_HTML_STRIP_STYLING,
            },
            {
                text: 'To Markdown',
                value: ActionService.TYPE_HTML_TO_MARKDOWN,
            },
            {
                text: 'From Markdown',
                value: ActionService.TYPE_HTML_FROM_MARKDOWN,
            },
        ];
    }
    /**
     * Return an array of types that should show the with option
     */
    static get WITH_TYPES() {
        return [
            ActionService.TYPE_REPLACE,
            ActionService.TYPE_REPLACE_CI,
            ActionService.TYPE_PAD_START,
            ActionService.TYPE_PAD_END,
        ];
    }
    /**
     * Return an array of types that should show the separator option
     */
    static get SEPARATOR_TYPES() {
        return [
            ActionService.TYPE_APPEND,
            ActionService.TYPE_PREPEND,
            ActionService.TYPE_SPLIT,
            ActionService.TYPE_JOIN,
        ];
    }
    /**
     * Return an array of types that should not have a value
     */
    static get STANDALONE_TYPES() {
        return [
            ActionService.TYPE_CEIL,
            ActionService.TYPE_FLOOR,
            ActionService.TYPE_CASE_UPPER,
            ActionService.TYPE_CASE_LOWER,
            ActionService.TYPE_CASE_SENTENCE,
            ActionService.TYPE_CASE_TITLE,
            ActionService.TYPE_SLUG,
            ActionService.TYPE_ARRAY_CREATE,
            ActionService.TYPE_ARRAY_FILTER,
            ActionService.TYPE_HTML_STRIP_IMAGES,
            ActionService.TYPE_HTML_STRIP_STYLING,
            ActionService.TYPE_HTML_FROM_MARKDOWN,
            ActionService.TYPE_HTML_TO_MARKDOWN,
            ActionService.TYPE_URLENCODE,
        ];
    }
}
ActionService.TYPE_TAKE = 'take';
ActionService.TYPE_SET = 'set';
ActionService.TYPE_ADD = 'add';
ActionService.TYPE_SUBTRACT = 'subtract';
ActionService.TYPE_MULTIPLY = 'multiply';
ActionService.TYPE_DIVIDE = 'divide';
ActionService.TYPE_APPEND = 'append';
ActionService.TYPE_PREPEND = 'prepend';
ActionService.TYPE_TRIM = 'trim';
ActionService.TYPE_TRIM_START = 'trim_start';
ActionService.TYPE_TRIM_END = 'trim_end';
ActionService.TYPE_TRUNCATE = 'truncate';
ActionService.TYPE_ROUND = 'round';
ActionService.TYPE_ROUND_HALF_DOWN = 'round_half_down';
ActionService.TYPE_CEIL = 'ceil';
ActionService.TYPE_FLOOR = 'floor';
ActionService.TYPE_CASE_UPPER = 'upper_case';
ActionService.TYPE_CASE_LOWER = 'lower_case';
ActionService.TYPE_CASE_TITLE = 'title_case';
ActionService.TYPE_CASE_SENTENCE = 'sentence_case';
ActionService.TYPE_REPLACE = 'replace';
ActionService.TYPE_REPLACE_CI = 'replace_ci';
ActionService.TYPE_PAD_START = 'pad_start';
ActionService.TYPE_PAD_END = 'pad_end';
ActionService.TYPE_SLUG = 'slug';
ActionService.TYPE_SPLIT = 'split';
ActionService.TYPE_JOIN = 'join';
ActionService.TYPE_ARRAY_CREATE = 'array_convert';
ActionService.TYPE_ARRAY_APPEND = 'array_append';
ActionService.TYPE_ARRAY_PREPEND = 'array_prepend';
ActionService.TYPE_ARRAY_FILTER = 'array_filter';
ActionService.TYPE_ARRAY_EXTRACT = 'array_extract';
ActionService.TYPE_HTML_STRIP_IMAGES = 'strip_images';
ActionService.TYPE_HTML_STRIP_STYLING = 'strip_styling';
ActionService.TYPE_HTML_FROM_MARKDOWN = 'from_markdown';
ActionService.TYPE_HTML_TO_MARKDOWN = 'to_markdown';
ActionService.TYPE_URLENCODE = 'urlencode';
//# sourceMappingURL=action-service.js.map